import React from 'react';

function IndustryPreferencesSelectField() {
  return '';
}

export default IndustryPreferencesSelectField;
